import { useTranslation } from "react-i18next";
import { HorizontalLine, Text } from "../../elements";
import IframeModal from "./IframeModal";

const ScriptFromInterview = ({ interviewId }: { interviewId: string }) => {
    const { t } = useTranslation();

    return (
        <div className="script-from-interview-wrapper">
            <Text size="large" weight="semibold">
                {t("Interview.ScriptFromInterview.Title")}
            </Text>
            <HorizontalLine weight="semi-dark" />
            <div className="button-wrapper">
                <IframeModal interviewId={interviewId} />
            </div>
        </div>
    );
};

export default ScriptFromInterview;
